const actions = {
    SET_ANNOTATION: 'SET_ANNOTATION',
    SET_ANNOTATION_LABEL: 'SET_ANNOTATION_LABEL',
    SET_ANNOTATION_OBJECTS: 'SET_ANNOTATION_OBJECTS',
    READ_ANNOTATION_REQUEST: 'READ_ANNOTATION_REQUEST',
    READ_ANNOTATION_SUCCESS: 'READ_ANNOTATION_SUCCESS',
    READ_ANNOTATION_ERROR: 'READ_ANNOTATION_ERROR',
    UPDATE_ANNOTATION_REQUEST: 'UPDATE_ANNOTATION_REQUEST',
    UPDATE_ANNOTATION_SUCCESS: 'UPDATE_ANNOTATION_SUCCESS',
    UPDATE_ANNOTATION_ERROR: 'UPDATE_ANNOTATION_ERROR',
    DELETE_ANNOTATION_REQUEST: 'DELETE_ANNOTATION_REQUEST',
    DELETE_ANNOTATION_SUCCESS: 'DELETE_ANNOTATION_SUCCESS',
    DELETE_ANNOTATION_ERROR: 'DELETE_ANNOTATION_ERROR',
    ANNOTATION_RESET_STATE: 'ANNOTATION_RESET_STATE',

    setAnnotation: annotation => ({
        type: actions.SET_ANNOTATION,
        annotation,
    }),
    setLabel: label => ({
        type: actions.SET_ANNOTATION_LABEL,
        label,
    }),
    setObjects: objects => ({
        type: actions.SET_ANNOTATION_OBJECTS,
        objects,
    }),
    readAnnotation: () => ({
        type: actions.READ_ANNOTATION_REQUEST,
    }),
    updateAnnotation: (id, request) => ({
        type: actions.UPDATE_ANNOTATION_REQUEST,
        id,
        request,
    }),
    deleteAnnotation: id => ({
        type: actions.DELETE_ANNOTATION_REQUEST,
        id,
    }),
    resetState: () => ({
        type: actions.ANNOTATION_RESET_STATE,
    }),
};
export default actions;
